
  import { Component, Vue,Inject, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import draggable from 'vuedraggable'
  @Component({  
    name: '',
    components: {
      PageFooter,
      draggable
    }
  })

  export default class ProductList extends Vue {
    @Inject() information:any
    get value(){
      return this.information
    }
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }
    

    private del(e){
      this.editmsg.menuList.splice(e,1)
    }
    private pushmenu(){
      this.editmsg.menuList.push({
        key:'',
        name:'定位菜单'+(this.editmsg.menuList.length+1),
        startTime:'',
        endTime:'',
      })
    }
  }
